
import Component from 'vue-class-component'
import Vue from 'vue'
import {State} from 'vuex-class'

import {Extra, User} from '../models/user'
import {User as Storeuser} from '../store/index'

import GridHeader from '../models/gridHeader'

import BlueButton from '../components/Atomic/BlueButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import CardTable from '../components/Layout/CardTable.vue'

import CreateExtra from '../components/Extras/CreateExtra.vue'
import UpdateExtra from '../components/Extras/UpdateExtra.vue'
import DeleteExtra from '../components/Extras/DeleteExtra.vue'
import ManageOrganisations from '../components/Extras/ManageOrganisations.vue'

import ExtrasService from '../services/ExtrasService'
import {INotificationService} from '@/services/NotificationService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import ResetSinglePassword from '@/components/Users/ResetSinglePassword.vue'

import {sortStringValues} from '../utils/utils'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'
import {Organisation} from "@/models/organisation";
import OrganisationsService from "@/services/OrganisationsService";
import {FALSE} from "sass";
import ExtraCsvExport from "@/components/Extras/ExtraCsvExport.vue";

@Component({
  components: {
      ExtraCsvExport,
    ToolTipButton,
    BlueButton,
    CardTable,
    CreateExtra,
    UpdateExtra,
    DeleteExtra,
    HelpTooltip,
    ManageOrganisations,
    CardTitle,
    ResetSinglePassword,
    RedButton,
  },
})
export default class Extras extends Vue {
  public $refs!: {
    createExtraDialog: CreateExtra,
    manageOrganisationsDialog: ManageOrganisations,
  }
  @State private user!: Storeuser

  private isPending: boolean = false
  private extraUsers: Extra[] = []
  private filteredUsers: Extra[] = []
  private headers: GridHeader[] = []
  private basicSearch: string = ''

  private firstNames: string[] = []
  private lastNames: string[] = []
  private authorities: string[] = []
  private departments: string[] = []
  private entities: string[] = []
  private units: string[] = []

  private selectedFirstName: string = ''
  private selectedLastName: string = ''
  private selectedAuthority: string = ''
  private selectedDepartment: string = ''
  private selectedEntity: string = ''
  private selectedUnit: string = ''

  // Used for notification.
  private $notificationService!: INotificationService

  // Used to handle errors
  private errorHandlerService: ErrorHandlerService

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  public mounted() {
    this.generateHeaders()
    this.fetchExtras()
  }

  private generateHeaders() {
    this.headers.push(
        new GridHeader(this.$t('Name').toString(), 'nom', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('FirstName').toString(), 'prenom', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('IUP').toString(), 'iup', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Email').toString(), 'courriel', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('EXTRAS.Authority').toString(), 'authority', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('EXTRAS.Department').toString(), 'department', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('EXTRAS.Entity').toString(), 'entity', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('EXTRAS.Unit').toString(), 'unit', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('EXTRAS.Licence').toString(), 'licence', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(this.$t('Actions').toString(), 'actions', 'center fixed', true, 100, 'fixed'),
    )
  }

  private async fetchExtras() {
    this.isPending = true
    try {
      this.extraUsers = await ExtrasService.get()
      this.extraUsers.forEach((user) => this.populateUserData(user))
      this.sortData()
      this.filterLogical()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
  }

  private resetUnitFilter(){
    this.units = []
    this.selectedUnit = ''
  }

  private resetEntityFilter() {
    this.entities = []
    this.selectedEntity = ''
  }

  private resetDepartmentFilter(){
    this.departments = []
    this.selectedDepartment = ''
  }

  private authoritySelected(){
    this.resetDepartmentFilter()
    this.resetEntityFilter()
    this.resetUnitFilter()
    this.filterLogical()
  }

  private departmentSelected(){
    this.resetEntityFilter()
    this.resetUnitFilter()
    this.filterLogical()
  }

  private entitySelected(){
    this.resetUnitFilter()
    this.filterLogical()
  }

  private filterLogical() {
    this.filteredUsers = this.extraUsers.filter((user) => {
      if (this.selectedFirstName && this.selectedFirstName !== user.prenom) {
        return false
      }
      if (this.selectedLastName && this.selectedLastName !== user.nom) {
        return false
      }
      if (this.selectedAuthority && this.selectedAuthority !== user.authority) {
        return false
      }
      if (this.selectedDepartment && this.selectedDepartment !== user.department) {
        return false
      }
      if (this.selectedEntity && this.selectedEntity !== user.entity) {
        return false
      }
      if (this.selectedUnit && this.selectedUnit !== user.unit) {
        return false
      }
      return true
    })

    if (this.selectedAuthority && !this.selectedDepartment) {
      this.filteredUsers.forEach((user) => this.populateDepartment(user))
    }
    if (this.selectedDepartment && !this.selectedEntity) {
      this.filteredUsers.forEach((user) => this.populateEntity(user))
    }
    if (this.selectedEntity && !this.selectedUnit) {
      this.filteredUsers.forEach((user) => this.populateUnit(user))
    }
  }

  private populateUserData(user: Extra) {
    this.populateFirstName(user)
    this.populateLastName(user)
    this.populateAuthority(user)
  }

  private getSelectedRowsCount() {
      return this.filteredUsers.length
  }
  private populateFirstName(user: Extra) {
    if (!this.firstNames.includes(user.prenom)) {
      this.firstNames.push(user.prenom)
    }
  }

  private populateLastName(user: Extra) {
    if (!this.lastNames.includes(user.nom)) {
      this.lastNames.push(user.nom)
    }
  }
  private populateAuthority(user: Extra) {
    if (user.authority != null) {
      if (!this.authorities.includes(user.authority))
      {
        this.authorities.push(user.authority)
      }
    }
  }

  private populateDepartment(user: Extra) {
    if (user.department != null) {
      if (!this.departments.includes(user.department)) {
        this.departments.push(user.department)
      }
    }
  }

  private populateEntity(user: Extra) {
    if (user.entity != null) {
      if (!this.entities.includes(user.entity)) {
        this.entities.push(user.entity)
      }
    }
  }

  private populateUnit(user: Extra) {
    if (user.unit != null) {
      if (!this.units.includes(user.unit)) {
        this.units.push(user.unit)
      }
    }
  }

  private sortData() {
    sortStringValues(this.firstNames)
    sortStringValues(this.lastNames)
    sortStringValues(this.authorities)
  }


  private resetFilterDialog() {
    this.selectedFirstName = ''
    this.selectedLastName = ''
    this.selectedAuthority = ''
    this.selectedDepartment = ''
    this.selectedEntity = ''
    this.selectedUnit = ''
    this.filterLogical()
  }

  private showCreateExtra() {
    this.$refs.createExtraDialog.show()
  }

  private showManageOrganisations() {
    this.$refs.manageOrganisationsDialog.show()
  }

  private async handleDialogClose() {
    await this.fetchExtras()
  }
}
